namespace Matrix.Exceptions {
    export namespace ExceptionPolicyIgnoreService {
        export const baseUrl = 'Exceptions/ExceptionPolicyIgnore';

        export declare function Create(request: Serenity.SaveRequest<ExceptionPolicyIgnoreRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ExceptionPolicyIgnoreRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ExceptionPolicyIgnoreRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ExceptionPolicyIgnoreRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Exceptions/ExceptionPolicyIgnore/Create",
            Update = "Exceptions/ExceptionPolicyIgnore/Update",
            Delete = "Exceptions/ExceptionPolicyIgnore/Delete",
            Retrieve = "Exceptions/ExceptionPolicyIgnore/Retrieve",
            List = "Exceptions/ExceptionPolicyIgnore/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ExceptionPolicyIgnoreService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
